(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

  // Token public Storefront API (Headless -> Storefront API -> Public access token)
  var STOREFRONT_TOKEN = window.MLH_STOREFRONT_TOKEN || '';
  var STOREFRONT_API_VERSION = '2025-07';
  var STOREFRONT_ENDPOINT = location.origin + '/api/' + STOREFRONT_API_VERSION + '/graphql.json';

  var PROP_COLOR_KEY = 'Color';
  var PROP_AVAIL_KEY = 'Availability';

  function log() {
    if (!window.console) return;
    try { console.log.apply(console, arguments); } catch (e) {}
  }

  function warn() {
    if (!window.console) return;
    try { console.warn.apply(console, arguments); } catch (e) {}
  }

  log('[MBC] script loaded');

  function getCart() {
    return fetch(ROOT + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      keepalive: true
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to fetch cart.js');
      return res.json();
    });
  }

  function needsFix(item) {
    var p = item.properties || {};
    return !p[PROP_COLOR_KEY] || !p[PROP_AVAIL_KEY];
  }

  function toGid(variantId) {
    return 'gid://shopify/ProductVariant/' + variantId;
  }

  function uniqueStrings(arr) {
    var out = [];
    var seen = {};
    for (var i = 0; i < arr.length; i++) {
      var v = String(arr[i]);
      if (!seen[v]) {
        seen[v] = true;
        out.push(v);
      }
    }
    return out;
  }

  // Returneaza "map" ES5: { "<variantIdNumeric>": node }
  function fetchVariantNodes(variantIds) {
    if (!STOREFRONT_TOKEN) {
      warn('[MBC] Missing STOREFRONT_TOKEN');
      return Promise.resolve({});
    }

    var ids = [];
    for (var i = 0; i < variantIds.length; i++) ids.push(toGid(variantIds[i]));

    var query =
      'query ($ids: [ID!]!) {' +
      '  nodes(ids: $ids) {' +
      '    ... on ProductVariant {' +
      '      id' +
      '      availableForSale' +
      '      quantityAvailable' +
      '      product { metafield(namespace: "custom", key: "mlh_internal_color_name") { value } }' +
      '    }' +
      '  }' +
      '}';

    return fetch(STOREFRONT_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query: query, variables: { ids: ids } }),
      cache: 'no-store',
      keepalive: true
    }).then(function (res) {
      return res.text().then(function (raw) {
        log('[MBC] Storefront status:', res.status);
        // log('[MBC] Storefront raw:', raw);

        var json;
        try { json = JSON.parse(raw); }
        catch (e) { throw new Error('Non-JSON response from Storefront API'); }

        if (json && json.errors) warn('[MBC] Storefront errors:', json.errors);
        if (!res.ok) throw new Error('Storefront API request failed');

        var out = {};
        var nodes = (json && json.data && json.data.nodes) ? json.data.nodes : [];

        for (var k = 0; k < nodes.length; k++) {
          var n = nodes[k];
          if (!n || !n.id) continue;
          var numericId = String(n.id).split('/').pop();
          out[numericId] = n;
        }

        return out;
      });
    });
  }

  function computeAvailability(node) {
    if (!node) return null;
    if (node.availableForSale === false) return 'sold out';

    var qty = node.quantityAvailable;
    if (qty === null || typeof qty === 'undefined') {
      return 'STOCK';
    }
    if (qty <= 0) return 'PREORDER';
    return 'STOCK';
  }

  function mergeObjects(a, b) {
    var out = {}, k;
    if (a) for (k in a) if (Object.prototype.hasOwnProperty.call(a, k)) out[k] = a[k];
    if (b) for (k in b) if (Object.prototype.hasOwnProperty.call(b, k)) out[k] = b[k];
    return out;
  }

  function changeLineItemProperties(itemKey, quantity, newProperties) {
    return fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: itemKey,          // key, nu variant_id
        quantity: quantity,
        properties: newProperties
      }),
      cache: 'no-store',
      keepalive: true
    }).then(function (res) {
      if (!res.ok) throw new Error('cart/change.js failed');
      return res.json();
    });
  }

  // --- Prestige native UI helpers (refresh + open drawer) ---

  function refreshThemeCartUI() {
    // Maestrooo / Prestige: cart:refresh pe documentElement refresh UI (count, drawer contents etc.)
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {
      // Fallback pt browsere vechi
      try {
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent('cart:refresh', true, false, {});
        document.documentElement.dispatchEvent(evt);
      } catch (e2) {}
    }
  }

  function openPrestigeCartDrawer() {
    // Incercam metoda nativa a drawer-ului (x-drawer.show())
    var drawer =
      document.querySelector('x-drawer#cart-drawer') ||
      document.querySelector('#cart-drawer x-drawer') ||
      document.querySelector('#cart-drawer');

    if (drawer && typeof drawer.show === 'function') {
      try { drawer.show(); return true; } catch (e) {}
    }

    // Fallback: click pe butonul care controleaza drawer-ul
    var btn =
      document.querySelector('[aria-controls="cart-drawer"]') ||
      document.querySelector('[data-action="open-drawer"][aria-controls="cart-drawer"]');

    if (btn && typeof btn.click === 'function') {
      btn.click();
      return true;
    }

    return false;
  }

  function showMinicartFeedback() {
    // 1) refresh UI
    refreshThemeCartUI();

    // 2) open drawer
    // uneori e nevoie de un micro-delay ca theme refresh sa apuce sa injecteze continut
    setTimeout(function () {
      openPrestigeCartDrawer();
    }, 50);
  }

  function fixMbcAddedItems() {
    return getCart().then(function (cart) {
      var items = cart && cart.items ? cart.items : [];
      var candidates = [];

      for (var i = 0; i < items.length; i++) {
        if (needsFix(items[i])) candidates.push(items[i]);
      }

      if (!candidates.length) return Promise.resolve();

      var variantIds = [];
      for (var j = 0; j < candidates.length; j++) variantIds.push(String(candidates[j].variant_id));
      variantIds = uniqueStrings(variantIds);

      return fetchVariantNodes(variantIds).then(function (variantMap) {
        var promises = [];

        for (var k = 0; k < candidates.length; k++) {
          (function (item) {
            var node = variantMap[String(item.variant_id)];
            var merged = mergeObjects(item.properties || {}, {});

            // Color
            if (!merged[PROP_COLOR_KEY]) {
              var color = (node && node.product && node.product.metafield && node.product.metafield.value) ? node.product.metafield.value : null;
              if (color) merged[PROP_COLOR_KEY] = color;
            }

            // Availability
            if (!merged[PROP_AVAIL_KEY]) {
              var avail = computeAvailability(node);
              if (avail) merged[PROP_AVAIL_KEY] = avail;
            }

            if (!merged[PROP_COLOR_KEY] && !merged[PROP_AVAIL_KEY]) return;

            promises.push(
              changeLineItemProperties(item.key, item.quantity, merged).catch(function (e) {
                warn('[MBC] changeLineItemProperties error:', e && e.message ? e.message : e);
              })
            );
          })(candidates[k]);
        }

        return Promise.all(promises);
      });
    }).catch(function (e) {
      warn('[MBC] fixMbcAddedItems error:', e && e.message ? e.message : e);
    });
  }

  // Hook MBC
  document.addEventListener('MAKEBECOOL_BUNDLES.updateCart', function () {
    // Ruleaza fix-urile, apoi deschide minicart-ul nativ (Prestige)
    var p1 = fixMbcAddedItems();

    var p2 = new Promise(function (resolve) {
      setTimeout(function () {
        resolve(fixMbcAddedItems());
      }, 250);
    });

    Promise.all([p1, p2]).then(function () {
      showMinicartFeedback();
    });
  });

})();
